<template>
    <div class="device-management-page">
        <!-- 主分类Tab -->
        <el-tabs v-model="activeMainTab" type="border-card" class="main-tabs" @tab-click="handleMainTabChange">
            <el-tab-pane v-for="tab in mainTabs" :key="tab.name" :label="tab.label" :name="tab.name">
            </el-tab-pane>
        </el-tabs>

        <!-- 子分类Tab -->
        <el-tabs v-if="showSubTabs" v-model="activeSubTab" type="border-card" class="sub-tabs"
            @tab-click="handleSubTabChange">
            <el-tab-pane v-for="subTab in currentSubTabs" :key="subTab.name" :label="subTab.label" :name="subTab.name">
            </el-tab-pane>
        </el-tabs>

        <div class="content-area">
            <!-- 搜索表单区域 -->
            <el-form :inline="true" :model="searchForm" class="search-form" @submit.native.prevent>
                <el-form-item label="设备名称">
                    <el-input v-model="searchForm.deviceName" placeholder="请输入设备名称" clearable
                        @keyup.enter.native="handleSearch"></el-input>
                </el-form-item>
                <!-- 新增：仓库搜索（可选） -->
                <el-form-item label="仓库">
                    <el-select v-model="searchForm.houseId" placeholder="请选择仓库" clearable @change="handleSearch">
                        <el-option v-for="warehouse in warehouseList" :key="warehouse.houseId"
                            :label="warehouse.houseName" :value="warehouse.houseId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <template v-if="activeMainTab !== 'all'">
                        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
                    </template>
                </el-form-item>
            </el-form>

            <!-- 表格区域 -->
            <div style="height: 60vh; width: 100%; overflow: auto;">
                <el-table :data="displayRecordList" style="width: 100%;" border :header-cell-class-name="'table-header'"
                    v-loading="loading">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="deviceName" label="设备名称" align="center" />
                    <el-table-column prop="deviceSerialnumber" label="设备序列号" align="center" />
                    <el-table-column prop="deviceModel" label="设备型号" align="center" />
                    <el-table-column prop="photoUrl" label="设备图片" align="center" width="100">
                        <template slot-scope="scope">
                            <div class="image-container">
                                <img v-if="scope.row.photoUrl" :src="scope.row.photoUrl" alt="设备图片"
                                    class="preview-image"
                                    @click="previewImage(scope.row.photoUrl, scope.row.deviceName)">
                                <div v-else class="no-image">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="manufacturer" label="生产厂家" align="center" show-overflow-tooltip />
                    <el-table-column prop="maintenanceCycle" label="维保周期(天)" align="center" />
                    <el-table-column prop="maintenanceTime" label="上次维保时间" align="center" />
                    <el-table-column prop="nextMaintenance" label="下次维保时间" align="center" />
                    <el-table-column prop="countdown" label="维保倒计时(天)" align="center">
                        <template slot-scope="scope">
                            <span :class="{ 'text-danger': scope.row.countdown < 0 }">
                                {{ scope.row.countdown }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="功能间" align="center">
                        <template #default="scope">
                            {{ getRoomName(scope.row.roomId) }}
                        </template>
                    </el-table-column>
                    <!-- 新增：仓库列 -->
                    <el-table-column label="仓库" align="center" show-overflow-tooltip>
                        <template #default="scope">
                            {{ getWarehouseName(scope.row.houseId) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="320" align="center" fixed="right">
                        <template #default="scope">
                            <el-button type="warning" size="small" icon="el-icon-tools"
                                @click="handleViewDetail(scope.row)">
                                一键维保
                            </el-button>
                            <el-button size="mini" @click="openEditModal(scope.row)" type="success"
                                icon="el-icon-edit">修改</el-button>
                            <el-button @click="deleteDevice(scope.row)" type="danger" size="small"
                                icon="el-icon-delete">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页区域 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
        </div>

        <!-- 图片预览弹窗 -->
        <el-dialog :title="previewTitle" :visible.sync="previewVisible" width="50%" append-to-body
            class="image-preview-dialog" top="5vh">
            <div class="content">
                <img :src="previewImageUrl" style="max-height: 70vh; width: 100%; object-fit: contain;"
                    class="preview-img" />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="previewVisible = false">关闭</el-button>
                <el-button type="primary" icon="el-icon-download" @click="downloadImage">下载图片</el-button>
            </span>
        </el-dialog>

        <!-- 设备维保弹窗 -->
        <el-dialog title="设备维保" :visible.sync="maintenanceModalVisible" width="1000px" :close-on-click-modal="false"
            custom-class="device-modal" :modal-append-to-body="false" :append-to-body="true" :z-index="2000"
            @open="handleMaintenanceDialogOpen">
            <el-form ref="maintenanceForm" :model="maintenanceForm" :rules="maintenanceRules" label-width="120px"
                class="device-form">
                <el-form-item label="设备ID" prop="deviceId" style="display: none;">
                    <el-input v-model="maintenanceForm.deviceId" disabled></el-input>
                </el-form-item>
                <el-form-item label="设备名称" prop="deviceName">
                    <el-input v-model="maintenanceForm.deviceName" disabled></el-input>
                </el-form-item>
                <el-form-item label="设备序列号" prop="deviceSerialnumber">
                    <el-input v-model="maintenanceForm.deviceSerialnumber" disabled></el-input>
                </el-form-item>
                <el-form-item label="功能间" prop="roomName">
                    <el-input v-model="maintenanceForm.roomName" disabled></el-input>
                </el-form-item>
                <!-- 新增：维保弹窗显示仓库信息 -->
                <el-form-item label="仓库" prop="houseName">
                    <el-input v-model="maintenanceForm.houseName" disabled></el-input>
                </el-form-item>
                <el-form-item label="使用配件" prop="accessories">
                    <el-table :data="maintenanceForm.accessories" border style="width: 100%; margin-bottom: 10px;"
                        size="mini">
                        <el-table-column label="配件名称" align="center" prop="accessoriesName">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.accessoriesName" placeholder="选择配件名称" style="width: 100%;"
                                    @change="handleAccessoryChange(scope.row)">
                                    <el-option v-for="item in accessoriesList" :key="item.id"
                                        :label="item.accessoriesName" :value="item.accessoriesName">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="用量" align="center" prop="accessoriesNum">
                            <template slot-scope="scope">
                                <el-input-number v-model="scope.row.accessoriesNum" :min="1" :step="1"
                                    style="width: 100%;">
                                </el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="配件类型" align="center" prop="accessoriesType">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.accessoriesType" placeholder="配件类型" readonly></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" align="center" prop="remark">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.remark" placeholder="可选备注"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="60">
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-delete" size="mini"
                                    @click="removeAccessory(scope.$index)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-button type="primary" icon="el-icon-plus" size="mini" @click="addAccessory" plain>
                        添加配件
                    </el-button>
                </el-form-item>
                <el-form-item label="维保内容" prop="content">
                    <el-input v-model="maintenanceForm.content" type="textarea" :rows="3"
                        placeholder="请输入维保内容"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="maintenanceForm.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="操作人" prop="repairman">
                    <el-input v-model="maintenanceForm.repairman" placeholder="请输入操作人"></el-input>
                </el-form-item>
                <el-form-item label="维保前图片">
                    <el-upload action="#" ref="uploadBefore" list-type="picture-card" :file-list="imageLists.before"
                        :on-preview="handleImagePreview" :on-remove="handleImageRemove" :limit="2"
                        :on-exceed="handleExceed" :auto-upload="false"
                        :on-change="handleMaintenanceImageChange('before')">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                    <div slot="tip" class="el-upload__tip" style="margin-top: 5px;">
                        支持PNG/JPG格式，大小不超过200KB，最多上传2张
                    </div>
                </el-form-item>
                <el-form-item label="维保中图片">
                    <el-upload action="#" ref="uploadDuring" list-type="picture-card" :file-list="imageLists.during"
                        :on-preview="handleImagePreview" :on-remove="handleImageRemove" :limit="2"
                        :on-exceed="handleExceed" :auto-upload="false"
                        :on-change="handleMaintenanceImageChange('during')">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                    <div slot="tip" class="el-upload__tip" style="margin-top: 5px;">
                        支持PNG/JPG格式，大小不超过200KB，最多上传2张
                    </div>
                </el-form-item>
                <el-form-item label="维保后图片">
                    <el-upload action="#" ref="uploadAfter" list-type="picture-card" :file-list="imageLists.after"
                        :on-preview="handleImagePreview" :on-remove="handleImageRemove" :limit="2"
                        :on-exceed="handleExceed" :auto-upload="false"
                        :on-change="handleMaintenanceImageChange('after')">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                    <div slot="tip" class="el-upload__tip" style="margin-top: 5px;">
                        支持PNG/JPG格式，大小不超过200KB，最多上传2张
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="maintenanceModalVisible = false">取消</el-button>
                <el-button type="primary" @click="submitMaintenanceForm" :loading="submitLoading">
                    确定
                </el-button>
            </div>
        </el-dialog>

        <!-- 新增设备弹窗 -->
        <el-dialog title="新增设备" :visible.sync="addDeviceModalVisible" width="700px" :close-on-click-modal="false"
            custom-class="device-modal" :modal-append-to-body="false" :append-to-body="true" :z-index="2000"
            @open="handleAddDialogOpen">
            <el-form ref="addDeviceForm" :model="addDeviceForm" :rules="addDeviceRules" label-width="120px"
                class="device-form">
                <el-form-item label="设备大类" prop="category">
                    <el-select v-model="addDeviceForm.category" placeholder="请选择主分类" clearable disabled>
                        <el-option v-for="tab in mainTabs" :key="tab.name" :label="tab.label" :value="tab.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备类型" prop="deviceType" v-if="addDeviceForm.category === intelligentTabName">
                    <el-select v-model="addDeviceForm.deviceType" placeholder="请选择子分类" clearable disabled>
                        <el-option v-for="subTab in intelligentSubTypes" :key="subTab.name" :label="subTab.label"
                            :value="subTab.name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="模板名称" prop="deviceModel">
                    <el-select v-model="addDeviceForm.deviceModel" placeholder="选择模板" clearable
                        @change="handleModelChange">
                        <el-option v-for="model in deviceModelList" :key="model.id" :label="model.deviceModel"
                            :value="model.deviceModel">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="功能间" prop="roomId">
                    <el-select v-model="addDeviceForm.roomId" placeholder="请选择功能间" clearable>
                        <el-option v-for="room in roomList" :key="room.id" :label="room.roomName" :value="room.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- 新增：仓库下拉框 -->
                <el-form-item label="仓库" prop="houseId">
                    <el-select v-model="addDeviceForm.houseId" placeholder="请选择仓库" clearable>
                        <el-option v-for="warehouse in warehouseList" :key="warehouse.houseId"
                            :label="warehouse.houseName" :value="warehouse.houseId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备名称" prop="deviceName">
                    <el-input v-model="addDeviceForm.deviceName" placeholder="请输入设备名称"></el-input>
                </el-form-item>
                <el-form-item label="设备序列号" prop="deviceSerialnumber">
                    <el-input v-model="addDeviceForm.deviceSerialnumber" placeholder="请输入设备序列号"></el-input>
                </el-form-item>
                <el-form-item label="IP地址" prop="ip">
                    <el-input v-model="addDeviceForm.ip" placeholder="请输入IP地址"></el-input>
                </el-form-item>
                <el-form-item label="主题" prop="topic">
                    <el-input v-model="addDeviceForm.topic" placeholder="请输入设备对应的dtu订阅主题"></el-input>
                </el-form-item>
                <el-form-item label="周期" prop="maintenanceCycle">
                    <el-input v-model="addDeviceForm.maintenanceCycle" placeholder="请输入周期"></el-input>
                </el-form-item>
                <el-form-item label="生产厂家" prop="manufacturer">
                    <el-input v-model="addDeviceForm.manufacturer" placeholder="请输入生产厂家"></el-input>
                </el-form-item>
                <el-form-item label="上次维保时间" prop="maintenanceTime">
                    <el-date-picker v-model="addDeviceForm.maintenanceTime" type="datetime" placeholder="选择上次维保时间"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="下次维保时间" prop="nextMaintenance">
                    <el-date-picker v-model="addDeviceForm.nextMaintenance" type="datetime" placeholder="选择下次维保时间"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addDeviceModalVisible = false">取消</el-button>
                <el-button type="primary" @click="submitAddDeviceForm" :loading="submitLoading">
                    确定
                </el-button>
            </div>
        </el-dialog>

        <!-- 修改设备弹窗 -->
        <el-dialog title="修改设备" :visible.sync="editDeviceModalVisible" width="700px" :close-on-click-modal="false"
            custom-class="device-modal" :modal-append-to-body="false" :append-to-body="true" :z-index="2000"
            @open="handleEditDialogOpen">
            <el-form ref="editDeviceForm" :model="editDeviceForm" :rules="editDeviceRules" label-width="120px"
                class="device-form">
                <el-form-item label="设备ID" prop="id" style="display: none;">
                    <el-input v-model="editDeviceForm.id" disabled></el-input>
                </el-form-item>
                <el-form-item label="设备大类" prop="category">
                    <el-select v-model="editDeviceForm.category" placeholder="请选择主分类" clearable disabled>
                        <el-option v-for="tab in mainTabs" :key="tab.name" :label="tab.label" :value="tab.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备类型" prop="deviceType" v-if="editDeviceForm.category === intelligentTabName">
                    <el-select v-model="editDeviceForm.deviceType" placeholder="请选择子分类" clearable disabled>
                        <el-option v-for="subTab in intelligentSubTypes" :key="subTab.name" :label="subTab.label"
                            :value="subTab.name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="模板名称" prop="deviceModel">
                    <el-select v-model="editDeviceForm.deviceModel" placeholder="选择模板" clearable disabled>
                        <el-option v-for="model in deviceModelList" :key="model.id" :label="model.deviceModel"
                            :value="model.deviceModel">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="功能间" prop="roomId">
                    <el-select v-model="editDeviceForm.roomId" placeholder="请选择功能间" clearable>
                        <el-option v-for="room in roomList" :key="room.id" :label="room.roomName" :value="room.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- 新增：修改弹窗仓库下拉框 -->
                <el-form-item label="仓库" prop="houseId">
                    <el-select v-model="editDeviceForm.houseId" placeholder="请选择仓库" clearable>
                        <el-option v-for="warehouse in warehouseList" :key="warehouse.houseId"
                            :label="warehouse.houseName" :value="warehouse.houseId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备名称" prop="deviceName">
                    <el-input v-model="editDeviceForm.deviceName" placeholder="请输入设备名称"></el-input>
                </el-form-item>
                <el-form-item label="设备序列号" prop="deviceSerialnumber">
                    <el-input v-model="editDeviceForm.deviceSerialnumber" placeholder="请输入设备序列号"></el-input>
                </el-form-item>
                <el-form-item label="IP地址" prop="ip">
                    <el-input v-model="editDeviceForm.ip" placeholder="请输入IP地址"></el-input>
                </el-form-item>
                <el-form-item label="主题" prop="topic">
                    <el-input v-model="editDeviceForm.topic" placeholder="请输入设备对应的dtu订阅主题"></el-input>
                </el-form-item>
                <el-form-item label="周期" prop="maintenanceCycle">
                    <el-input v-model="editDeviceForm.maintenanceCycle" placeholder="请输入周期"></el-input>
                </el-form-item>
                <el-form-item label="生产厂家" prop="manufacturer">
                    <el-input v-model="editDeviceForm.manufacturer" placeholder="请输入生产厂家"></el-input>
                </el-form-item>

                <el-form-item label="设备图片">
                    <el-upload ref="editDeviceImageUpload" action="#" list-type="picture-card"
                        :file-list="editDeviceImageList" :on-preview="handleImagePreview"
                        :on-remove="handleEditDeviceImageRemove" :on-change="handleEditDeviceImageChange" :limit="1"
                        :on-exceed="handleExceed" :auto-upload="false">
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                    <div slot="tip" class="el-upload__tip" style="margin-top: 5px;">
                        支持PNG/JPG格式，大小不超过200KB，最多上传1张
                    </div>
                </el-form-item>

                <el-form-item label="上次维保时间" prop="maintenanceTime">
                    <el-date-picker v-model="editDeviceForm.maintenanceTime" type="datetime" placeholder="选择上次维保时间"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="下次维保时间" prop="nextMaintenance">
                    <el-input v-model="editDeviceForm.nextMaintenance" type="datetime" placeholder="选择下次维保时间"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDeviceModalVisible = false">取消</el-button>
                <el-button type="primary" @click="submitEditDeviceForm" :loading="submitLoading">
                    确定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getDeviceList, getDeviceTypeList, getDeviceCategoryList, addDevice, getDeviceModeList, delDevice, edit } from "@/api/device";
import { getRoomList } from "@/api/function";
import { getMaintenance } from "@/api/devicelist";
import { getModelLinkAccessories } from "@/api/accessories";
import { getHouseList, getHouseListByPid } from "@/api/terminal";
export default {

    data() {
        return {
            mainTabs: [{ name: 'all', label: '全部' }],
            intelligentSubTypes: [],
            activeMainTab: 'all',
            activeSubTab: '',
            searchForm: {
                deviceName: '',
                houseId: null // 新增：仓库搜索参数
            },

            allDeviceList: [], // 新增：存储所有设备的原始数据（本地全量）
            deviceList: [], // 筛选后的设备列表
            displayRecordList: [], // 分页后显示的数据列表
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            loading: false,

            roomList: [],
            deviceCategories: [],
            deviceTypes: [],
            accessoriesList: [],
            warehouseList: [], // 仓库列表

            previewVisible: false,
            previewImageUrl: '',
            previewTitle: '',
            maintenanceModalVisible: false,
            addDeviceModalVisible: false,
            editDeviceModalVisible: false,
            submitLoading: false,

            maintenanceForm: {
                deviceId: '', deviceName: '', deviceSerialnumber: '',
                roomName: '', houseName: '', // 新增：仓库名称
                accessories: [],
                content: '', remark: '', repairman: ''
            },
            accessoryRow: { accessoriesName: '', accessoriesNum: 1, accessoriesType: '', remark: '' },

            addDeviceForm: {
                category: '', deviceType: '', roomId: '',
                houseId: '', // 新增：仓库ID
                deviceName: '', deviceSerialnumber: '', deviceModel: '',
                ip: '', maintenanceTime: '', nextMaintenance: '', topic: '',
                maintenanceCycle: '', manufacturer: '', photoUrl: ''
            },

            editDeviceForm: {
                id: '',
                category: '', deviceType: '', roomId: '',
                houseId: '', // 新增：仓库ID
                deviceName: '', deviceSerialnumber: '', deviceModel: '',
                ip: '', maintenanceTime: '', nextMaintenance: '', topic: '',
                maintenanceCycle: '', manufacturer: '', photoUrl: ''
            },

            editDeviceImageList: [],
            editDeviceImageFile: null,

            imageLists: {
                before: [],
                during: [],
                after: []
            },

            deviceModelList: [],
        };
    },
    computed: {
        intelligentTabName() {
            const intelligentTab = this.mainTabs.find(tab => tab.label === '智能设备');
            return intelligentTab ? intelligentTab.name : null;
        },
        currentSubTabs() {
            return this.activeMainTab === this.intelligentTabName ? this.intelligentSubTypes : [];
        },
        showSubTabs() {
            return this.activeMainTab === this.intelligentTabName && this.currentSubTabs.length > 0;
        },
        maintenanceRules() {
            return {
                content: [
                    { required: true, message: '维保内容不能为空', trigger: 'blur' },
                    { min: 5, message: '维保内容至少输入5个字符', trigger: 'blur' }
                ],
                repairman: [
                    { required: true, message: '请输入操作人', trigger: 'blur' }
                ],
                accessories: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value.length === 0) return callback(new Error('请至少添加一个配件'));
                            for (const item of value) {
                                if (!item.accessoriesName) return callback(new Error('请为所有配件选择名称'));
                                if (!item.accessoriesNum || item.accessoriesNum <= 0) return callback(new Error('配件用量必须为正整数'));
                            }
                            callback();
                        }, trigger: 'change'
                    }
                ]
            };
        },
        addDeviceRules() {
            return {
                category: [{ required: true, message: '主分类不能为空', trigger: 'change' }],
                deviceType: [{ required: true, message: '子分类不能为空', trigger: 'change' }],
                // roomId: [{ required: true, message: '请选择功能间', trigger: 'change' }],
                deviceName: [{ required: true, message: '设备名称不能为空', trigger: 'blur' }],
                deviceSerialnumber: [{ required: true, message: '设备序列号不能为空', trigger: 'blur' }],
                maintenanceTime: [{ required: true, message: '上次维保时间不能为空', trigger: 'change' }],
                nextMaintenance: [{ required: true, message: '下次维保时间不能为空', trigger: 'change' }],
                // houseId非必填，不添加验证规则
            };
        },
        editDeviceRules() {
            return {
                category: [{ required: true, message: '主分类不能为空', trigger: 'change' }],
                deviceType: [{ required: true, message: '子分类不能为空', trigger: 'change' }],
                // roomId: [{ required: true, message: '请选择功能间', trigger: 'change' }],
                deviceName: [{ required: true, message: '设备名称不能为空', trigger: 'blur' }],
                deviceSerialnumber: [{ required: true, message: '设备序列号不能为空', trigger: 'blur' }],
                maintenanceTime: [{ required: true, message: '上次维保时间不能为空', trigger: 'change' }],
                nextMaintenance: [{ required: true, message: '下次维保时间不能为空', trigger: 'change' }],
                // houseId非必填，不添加验证规则
            };
        }
    },
    watch: {
        activeMainTab(newVal) {
            if (newVal === this.intelligentTabName && this.intelligentSubTypes.length > 0) {
                this.activeSubTab = this.intelligentSubTypes[0].name;
            } else {
                this.activeSubTab = '';
            }
            this.currentPage = 1;
            this.filterDevices(); // 改为本地筛选
        },
        activeSubTab() {
            this.currentPage = 1;
            this.filterDevices(); // 子Tab切换也本地筛选
        },
        currentPage() {
            this.updateDisplayList();
        },
        pageSize() {
            this.updateDisplayList();
        },
        deviceList() {
            this.updateDisplayList();
        },
        // 新增：监听搜索框输入，实时筛选（可选）
        'searchForm.deviceName'(val) {
            if (val === '') {
                this.filterDevices(); // 清空搜索时重新筛选
            }
        },
        // 新增：监听仓库搜索
        'searchForm.houseId'() {
            this.currentPage = 1;
            this.filterDevices();
        }
    },
    async mounted() {
        try {
            await Promise.all([
                this.loadRoomList(),
                this.loadDeviceTypes(),
                this.loadDeviceCategories(),
                this.loadSubWarehouseList() // 加载仓库列表
            ]);
            if (this.activeMainTab === this.intelligentTabName && this.intelligentSubTypes.length > 0) {
                this.activeSubTab = this.intelligentSubTypes[0].name;
            }
            await this.loadAllDevices(); // 一次性加载所有设备
        } catch (error) {
            console.error("初始化数据失败:", error);
            this.$message.error("页面初始化失败，请刷新重试");
        }
    },
    created() {
        this.loadSubWarehouseList()
    },
    methods: {
        async loadSubWarehouseList() {
            try {
                const params = { userId: localStorage.getItem('userId'), pid: null };
                const mainWarehouseRes = await getHouseList(params);
                if (mainWarehouseRes && mainWarehouseRes.code === 200) {
                    const mainWarehouses = mainWarehouseRes.data || [];
                    const subWarehouseList = [];
                    for (const mainWarehouse of mainWarehouses) {
                        const subWarehouseRes = await getHouseListByPid({
                            userId: localStorage.getItem('userId'),
                            pid: mainWarehouse.houseId
                        });
                        if (subWarehouseRes && subWarehouseRes.code === 200) {
                            const subWarehouses = subWarehouseRes.data || [];
                            const pureSubWarehouses = subWarehouses.filter(item => item.pid && item.pid !== item.houseId);
                            subWarehouseList.push(...pureSubWarehouses);
                        }
                    }
                    this.warehouseList = subWarehouseList;
                    // 备用数据：如果接口返回空，使用示例数据
                    if (this.warehouseList.length === 0) {
                        this.warehouseList = [
                            {
                                "code": "YL01",
                                "houseId": 43,
                                "pid": 2,
                                "houseName": "大火锅原料库",
                                "room": "测试功能间",
                                "address": "192.168.0.1",
                                "createTime": "2026-02-09 10:50:25",
                                "operator": "陈",
                                "tenantId": null,
                                "userId": null,
                                "orgId": "2efbfd93-b218-480b-8a2f-f92c15fe1163",
                                "htemp": null,
                                "hhum": null
                            },
                            {
                                "code": "QC001",
                                "houseId": 39,
                                "pid": 3,
                                "houseName": "切菜仓库1",
                                "room": "切菜间",
                                "address": "192.168.1.101",
                                "createTime": "2025-10-24 09:42:50",
                                "operator": null,
                                "tenantId": null,
                                "userId": null,
                                "orgId": "2efbfd93-b218-480b-8a2f-f92c15fe1163",
                                "htemp": null,
                                "hhum": null
                            },
                            {
                                "code": "CS001",
                                "houseId": 45,
                                "pid": 44,
                                "houseName": "测试一号仓库",
                                "room": "测试功能间",
                                "address": "123.145.111",
                                "createTime": "2026-03-01 10:24:51",
                                "operator": "崔潇瑞11",
                                "tenantId": null,
                                "userId": null,
                                "orgId": "2efbfd93-b218-480b-8a2f-f92c15fe1163",
                                "htemp": null,
                                "hhum": null
                            }
                        ];
                    }
                    console.log('仓库列表:', this.warehouseList);

                }
            } catch (error) {
                console.error('加载子仓列表失败:', error);
                this.$message.error('子仓列表加载失败，将使用默认子仓数据');
                // 默认仓库数据
                this.warehouseList = [
                    {
                        "code": "YL01",
                        "houseId": 43,
                        "pid": 2,
                        "houseName": "大火锅原料库",
                        "room": "测试功能间",
                        "address": "192.168.0.1",
                        "createTime": "2026-02-09 10:50:25",
                        "operator": "陈",
                        "tenantId": null,
                        "userId": null,
                        "orgId": "2efbfd93-b218-480b-8a2f-f92c15fe1163",
                        "htemp": null,
                        "hhum": null
                    },
                    {
                        "code": "QC001",
                        "houseId": 39,
                        "pid": 3,
                        "houseName": "切菜仓库1",
                        "room": "切菜间",
                        "address": "192.168.1.101",
                        "createTime": "2025-10-24 09:42:50",
                        "operator": null,
                        "tenantId": null,
                        "userId": null,
                        "orgId": "2efbfd93-b218-480b-8a2f-f92c15fe1163",
                        "htemp": null,
                        "hhum": null
                    },
                    {
                        "code": "CS001",
                        "houseId": 45,
                        "pid": 44,
                        "houseName": "测试一号仓库",
                        "room": "测试功能间",
                        "address": "123.145.111",
                        "createTime": "2026-03-01 10:24:51",
                        "operator": "崔潇瑞11",
                        "tenantId": null,
                        "userId": null,
                        "orgId": "2efbfd93-b218-480b-8a2f-f92c15fe1163",
                        "htemp": null,
                        "hhum": null
                    }
                ];
            }
        },
        // 新增：根据houseId获取仓库名称
        getWarehouseName(houseId) {
            if (!houseId) return '未知';
            const warehouse = this.warehouseList.find(item => item.houseId === houseId);
            return warehouse ? warehouse.houseName : '未知';
        },
        // 通用文件校验方法（校验类型+大小≤200KB）
        validateUploadFile(file) {
            // 1. 校验是否为图片
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
                this.$message.error('只能上传图片文件！');
                return false;
            }

            // 2. 校验大小不超过200KB
            const isLt200K = file.size / 1024 < 200;
            if (!isLt200K) {
                this.$message.error('图片大小不能超过 200KB！');
                return false;
            }

            // 3. 限制图片格式（PNG/JPG/JPEG）
            const allowedFormats = ['image/png', 'image/jpg', 'image/jpeg'];
            if (!allowedFormats.includes(file.type)) {
                this.$message.error('仅支持 PNG/JPG/JPEG 格式的图片！');
                return false;
            }

            return true;
        },

        // 维保图片的change事件（区分before/during/after）
        handleMaintenanceImageChange(type) {
            return (file, fileList) => {
                // 仅在校验新选择的文件时触发（status=ready）
                if (file.status === 'ready') {
                    const isValid = this.validateUploadFile(file.raw);
                    if (!isValid) {
                        // 校验失败：清空当前类型的文件列表
                        this.imageLists[type] = [];
                        return;
                    }
                }
                // 校验通过：更新文件列表
                this.imageLists[type] = fileList;
            };
        },

        // 编辑设备图片的change事件（加入大小校验）
        handleEditDeviceImageChange(file, fileList) {
            // 仅在校验新选择的文件时触发
            if (file.status === 'ready') {
                const isValid = this.validateUploadFile(file.raw);
                if (!isValid) {
                    // 校验失败：清空文件列表，重置图片文件
                    this.editDeviceImageList = [];
                    this.editDeviceImageFile = null;
                    return;
                }
                // 校验通过：记录文件
                this.editDeviceImageFile = file.raw;
            }
            // 更新文件列表
            this.editDeviceImageList = fileList;
        },

        async deleteDevice(row) {
            this.$confirm(`确定要删除 ${row.deviceModel} 吗?`, '提示', { type: 'warning' })
                .then(async () => {
                    try {
                        await delDevice({ id: row.id });
                        this.$message.success('删除成功');
                        await this.loadAllDevices(); // 删除后重新加载全量数据
                    } catch (error) {
                        console.error('删除设备失败：', error);
                        this.$message.error('操作异常，请重试');
                    }
                }).catch(() => {
                    this.$message.info('已取消删除');
                });
        },

        async getList() {
            try {
                const response = await getDeviceModeList({
                    param2: this.addDeviceForm.category,
                    param1: this.addDeviceForm.deviceType,
                    userId: localStorage.getItem('userId')
                });
                this.deviceModelList = response.data || [];
            } catch (error) {
                console.error("获取设备模板列表失败:", error);
                this.$message.error("获取设备模板列表失败，请稍后重试");
                this.deviceModelList = [];
            }
        },

        async getEditList() {
            try {
                const response = await getDeviceModeList({
                    param2: this.editDeviceForm.category,
                    param1: this.editDeviceForm.deviceType,
                    userId: localStorage.getItem('userId')
                });
                this.deviceModelList = response.data || [];
            } catch (error) {
                console.error("获取设备模板列表失败:", error);
                this.$message.error("获取设备模板列表失败，请稍后重试");
                this.deviceModelList = [];
            }
        },

        async loadDeviceTypes() {
            try {
                const res = await getDeviceTypeList({ userId: localStorage.getItem('userId') });
                const types = res.data || [];
                this.deviceTypes = types.map(t => ({ id: t.id, name: t.typeName, label: t.typeName, categoryId: t.categoryId }));
                this.intelligentSubTypes = types.map(t => ({ name: t.typeName, label: t.typeName }));
            } catch (error) {
                this.$message.error('加载设备类型失败');
                console.error(error);
            }
        },

        async loadDeviceCategories() {
            try {
                const res = await getDeviceCategoryList({ userId: localStorage.getItem('userId') });
                const categoriesFromServer = res.data || [];
                this.deviceCategories = categoriesFromServer;
                const newTabsFromServer = categoriesFromServer.map(categoryLabel => ({
                    name: categoryLabel,
                    label: categoryLabel
                }));
                this.mainTabs = [{ name: 'all', label: '全部' }, ...newTabsFromServer];
            } catch (error) {
                this.$message.error('加载设备大类失败');
                console.error(error);
            }
        },

        async loadRoomList() {
            try {
                const res = await getRoomList({ userId: localStorage.getItem('userId') });
                this.roomList = res.data || [];
            } catch (error) {
                this.$message.error('加载功能间列表失败');
                console.error(error);
            }
        },

        // 新增：一次性加载所有设备数据到本地
        async loadAllDevices() {
            this.loading = true;
            try {
                const queryParams = {
                    userId: localStorage.getItem('userId'),
                    // 取消分页参数，拉取所有数据
                    pageNum: 1,
                    pageSize: 9999, // 足够大的数值确保拉取所有数据
                };

                const res = await getDeviceList(queryParams);

                // 处理两种后端返回格式
                let rawList = [];
                if (res.data && res.data.list) {
                    rawList = res.data.list || [];
                } else {
                    rawList = res.data || [];
                }

                // 日期格式化函数：宽松解析，兼容更多格式
                const formatDateToStr = (dateVal) => {
                    if (!dateVal) return '';

                    // 如果是数字（时间戳）
                    if (typeof dateVal === 'number') {
                        const date = new Date(dateVal);
                        if (isNaN(date.getTime())) return '';
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const day = String(date.getDate()).padStart(2, '0');
                        return `${year}-${month}-${day} `;
                    }

                    // 如果是字符串，先尝试直接转成日期对象
                    const date = new Date(dateVal);
                    if (!isNaN(date.getTime())) {
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const day = String(date.getDate()).padStart(2, '0');
                        return `${year}-${month}-${day} `;
                    }

                    // 实在解析不了才返回空
                    return '';
                };

                // 格式化所有设备数据并存储到本地全量列表
                this.allDeviceList = rawList.map(item => ({
                    ...item,
                    maintenanceTime: formatDateToStr(item.maintenanceTime),
                    nextMaintenance: formatDateToStr(item.nextMaintenance),
                    houseId: item.houseId || null // 确保houseId字段存在
                }));

                // 首次筛选数据
                this.filterDevices();

            } catch (error) {
                this.$message.error('加载设备列表异常，请重试');
                console.error('加载设备失败：', error);
                this.allDeviceList = [];
                this.deviceList = [];
                this.displayRecordList = [];
                this.totalCount = 0;
            } finally {
                this.loading = false;
            }
        },

        // 新增：本地筛选设备数据（核心前端搜索逻辑）
        filterDevices() {
            let filteredList = [...this.allDeviceList];

            // 1. 筛选主Tab
            if (this.activeMainTab !== 'all') {
                const activeTabObject = this.mainTabs.find(tab => tab.name === this.activeMainTab);
                if (activeTabObject) {
                    if (this.activeMainTab === this.intelligentTabName && this.activeSubTab) {
                        // 智能设备子分类筛选
                        filteredList = filteredList.filter(item => item.deviceType === this.activeSubTab);
                    } else {
                        // 其他主分类筛选
                        filteredList = filteredList.filter(item => item.deviceType === activeTabObject.label);
                    }
                }
            }

            // 2. 筛选设备名称（前端搜索核心逻辑）
            if (this.searchForm.deviceName) {
                const keyword = this.searchForm.deviceName.trim().toLowerCase();
                filteredList = filteredList.filter(item =>
                    item.deviceName && item.deviceName.toLowerCase().includes(keyword)
                );
            }

            // 3. 新增：筛选仓库
            if (this.searchForm.houseId) {
                filteredList = filteredList.filter(item => item.houseId === this.searchForm.houseId);
            }

            // 更新筛选后的列表和总数
            this.deviceList = filteredList;
            this.totalCount = filteredList.length;

            // 更新分页显示
            this.updateDisplayList();
        },

        updateDisplayList() {
            // 计算当前页显示的数据
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.displayRecordList = this.deviceList.slice(startIndex, endIndex);

            // 为显示列表添加序号
            this.displayRecordList = this.displayRecordList.map((item, index) => ({
                ...item,
                serialNumber: startIndex + index + 1
            }));
        },

        handleMainTabChange() {
            this.currentPage = 1;
            this.filterDevices(); // 改为本地筛选
        },

        handleSubTabChange() {
            this.currentPage = 1;
            this.filterDevices(); // 改为本地筛选
        },

        // 修改：前端搜索，不再调用后端
        handleSearch() {
            this.currentPage = 1;
            this.filterDevices(); // 仅本地筛选
        },

        resetSearch() {
            this.searchForm = {
                deviceName: '',
                houseId: null // 重置仓库搜索
            };
            this.handleSearch(); // 触发本地筛选
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            // 滚动到表格顶部
            const tableContainer = document.querySelector('.content-area > div[style*="height: 60vh"]');
            if (tableContainer) {
                tableContainer.scrollTop = 0;
            }
        },

        handleViewDetail(row) {
            this.resetMaintenanceForm();
            const room = this.roomList.find(r => r.id == row.roomId);
            const roomName = room ? room.roomName : '未知功能间';
            // 新增：获取仓库名称
            const houseName = this.getWarehouseName(row.houseId);
            this.maintenanceForm = {
                ...this.maintenanceForm,
                deviceId: row.id || row.deviceId || '',
                deviceName: row.deviceName || '',
                deviceSerialnumber: row.deviceSerialnumber || '',
                roomName: roomName,
                houseName: houseName // 赋值仓库名称
            };
            this.maintenanceModalVisible = true;
        },

        async handleMaintenanceDialogOpen() {
            await this.getAccessoriesList();
        },

        async getAccessoriesList() {
            try {
                const response = await getModelLinkAccessories();
                this.accessoriesList = response.data || [];
            } catch (error) {
                console.error("获取配件列表失败:", error);
                this.$message.error("获取配件列表失败，请稍后重试");
                this.accessoriesList = [];
            }
        },

        resetMaintenanceForm() {
            this.maintenanceForm = {
                deviceId: '',
                deviceName: '',
                deviceSerialnumber: '',
                roomName: '',
                houseName: '', // 重置仓库名称
                accessories: [],
                content: '',
                remark: '',
                repairman: ''
            };
            this.imageLists = { before: [], during: [], after: [] };
            this.$refs.uploadBefore?.clearFiles();
            this.$refs.uploadDuring?.clearFiles();
            this.$refs.uploadAfter?.clearFiles();
            this.submitLoading = false;
        },

        addAccessory() {
            this.maintenanceForm.accessories.push({ ...this.accessoryRow });
        },

        removeAccessory(index) {
            this.maintenanceForm.accessories.splice(index, 1);
            this.$refs.maintenanceForm.validateField('accessories');
        },

        handleAccessoryChange(row) {
            const selectedAccessory = this.accessoriesList.find(item => item.accessoriesName === row.accessoriesName);
            if (selectedAccessory) {
                row.accessoriesType = selectedAccessory.accessoriesType || '';
            } else {
                row.accessoriesType = '';
            }
        },

        async submitMaintenanceForm() {
            try {
                await this.$refs.maintenanceForm.validate();
                this.submitLoading = true;
                const formData = new FormData();
                formData.append('deviceId', this.maintenanceForm.deviceId);
                formData.append('deviceName', this.maintenanceForm.deviceName);
                formData.append('deviceSerialnumber', this.maintenanceForm.deviceSerialnumber);
                formData.append('content', this.maintenanceForm.content);
                formData.append('remark', this.maintenanceForm.remark);
                formData.append('repairman', this.maintenanceForm.repairman);
                formData.append('room', this.maintenanceForm.roomName);
                formData.append('accessoriesString', JSON.stringify(this.maintenanceForm.accessories));

                // 处理维保图片
                const getUploadFiles = (refName) => {
                    const uploadComponent = this.$refs[refName];
                    return uploadComponent?.uploadFiles || [];
                };
                getUploadFiles('uploadBefore').forEach(file => formData.append('front', file.raw));
                getUploadFiles('uploadDuring').forEach(file => formData.append('middle', file.raw));
                getUploadFiles('uploadAfter').forEach(file => formData.append('after', file.raw));

                const finalResponse = await getMaintenance(formData);
                if (finalResponse.code === 200 || finalResponse.success) {
                    this.$message.success('维保记录提交成功！');
                    this.maintenanceModalVisible = false;
                    await this.loadAllDevices(); // 重新加载全量数据
                } else {
                    this.$message.error(finalResponse.message || '维保记录提交失败');
                }
            } catch (error) {
                console.error('提交维保记录失败：', error);
                if (error.name !== 'ValidationError') {
                    const errorMsg = error.response?.data?.message || '提交过程中发生错误，请重试。';
                    this.$message.error(errorMsg);
                }
            } finally {
                this.submitLoading = false;
            }
        },

        handleAdd() {
            this.resetAddDeviceForm();
            this.addDeviceModalVisible = true;
        },

        openEditModal(row) {
            this.resetEditDeviceForm();

            // 日期格式化函数：宽松解析，兼容更多格式
            const formatDateToStr = (dateVal) => {
                if (!dateVal) return '';

                // 如果是数字（时间戳）
                if (typeof dateVal === 'number') {
                    const date = new Date(dateVal);
                    if (isNaN(date.getTime())) return '';
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const seconds = String(date.getSeconds()).padStart(2, '0');
                    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                }

                // 如果是字符串，先尝试直接转成日期对象
                const date = new Date(dateVal);
                if (!isNaN(date.getTime())) {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const seconds = String(date.getSeconds()).padStart(2, '0');
                    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                }

                // 实在解析不了才返回空
                return '';
            };

            this.editDeviceForm = {
                id: row.id || '',
                category: row.category || this.activeMainTab,
                deviceType: row.deviceType || this.activeSubTab,
                roomId: row.roomId || '',
                houseId: row.houseId || '', // 赋值仓库ID
                deviceName: row.deviceName || '',
                deviceSerialnumber: row.deviceSerialnumber || '',
                deviceModel: row.deviceModel || '',
                ip: row.ip || '',
                maintenanceTime: formatDateToStr(row.maintenanceTime),
                nextMaintenance: formatDateToStr(row.nextMaintenance),
                topic: row.topic || '',
                maintenanceCycle: row.maintenanceCycle || '',
                manufacturer: row.manufacturer || '',
                photoUrl: row.photoUrl || ''
            };

            this.editDeviceImageList = row.photoUrl ? [{
                name: '设备图片',
                url: row.photoUrl
            }] : [];
            this.editDeviceImageFile = null;

            this.editDeviceModalVisible = true;
        },

        async handleEditDialogOpen() {
            await this.getEditList();
        },

        resetEditDeviceForm() {
            this.editDeviceForm = {
                id: '',
                category: '', deviceType: '', roomId: '',
                houseId: '', // 重置仓库ID
                deviceName: '', deviceSerialnumber: '', deviceModel: '',
                ip: '', maintenanceTime: '', nextMaintenance: '', topic: '',
                maintenanceCycle: '', manufacturer: '', photoUrl: '',
                userId: localStorage.getItem('userId')
            };
            this.editDeviceImageList = [];
            this.editDeviceImageFile = null;
            this.submitLoading = false;
        },

        resetAddDeviceForm() {
            this.addDeviceForm = {
                category: '', deviceType: '', roomId: '',
                houseId: '', // 重置仓库ID
                deviceName: '', deviceSerialnumber: '', deviceModel: '',
                ip: '', maintenanceTime: '', nextMaintenance: '', topic: '',
                maintenanceCycle: '', manufacturer: '', photoUrl: '',
                userId: localStorage.getItem('userId')
            };
            this.submitLoading = false;
        },

        async handleAddDialogOpen() {
            this.addDeviceForm.category = this.activeMainTab;
            if (this.activeMainTab === this.intelligentTabName) {
                this.addDeviceForm.deviceType = this.activeSubTab;
            } else {
                this.addDeviceForm.deviceType = '';
            }
            await this.getList();
        },

        handleModelChange(selectedModelName) {
            if (!selectedModelName) {
                this.addDeviceForm.ip = '';
                this.addDeviceForm.maintenanceCycle = '';
                this.addDeviceForm.manufacturer = '';
                this.addDeviceForm.photoUrl = '';
                this.addDeviceForm.roomId = '';
                this.addDeviceForm.houseId = ''; // 清空仓库ID
                return;
            }

            const selectedModel = this.deviceModelList.find(model => model.deviceModel === selectedModelName);

            if (selectedModel) {
                this.addDeviceForm.ip = selectedModel.ip || '';
                this.addDeviceForm.maintenanceCycle = selectedModel.maintenanceCycle || '';
                this.addDeviceForm.manufacturer = selectedModel.manufacturer || '';
                this.addDeviceForm.photoUrl = selectedModel.photoUrl || '';
                this.addDeviceForm.roomId = selectedModel.roomId || '';
                this.addDeviceForm.houseId = selectedModel.houseId || ''; // 赋值仓库ID
            }
        },

        handleEditDeviceImageRemove(file, fileList) {
            this.editDeviceImageList = fileList;
            this.editDeviceImageFile = null;
            if (fileList.length === 0) {
                this.editDeviceForm.photoUrl = '';
            }
        },

        async submitAddDeviceForm() {
            try {
                await this.$refs.addDeviceForm.validate();
                this.submitLoading = true;

                const requestData = {
                    ...this.addDeviceForm,
                    userId: localStorage.getItem('userId') || '',
                    houseId: this.addDeviceForm.houseId || null // 传递仓库ID（非必填）
                };

                const response = await addDevice(requestData);

                if (response.code === 200 || response.success) {
                    this.$message.success('设备新增成功！');
                    this.addDeviceModalVisible = false;
                    await this.loadAllDevices(); // 重新加载全量数据
                } else {
                    this.$message.error(response.message || '设备新增失败');
                }
            } catch (error) {
                console.error('提交新设备失败：', error);
                if (error.name !== 'ValidationError') {
                    const errorMsg = error.response?.data?.message || '提交过程中发生错误，请重试。';
                    this.$message.error(errorMsg);
                }
            } finally {
                this.submitLoading = false;
            }
        },

        async submitEditDeviceForm() {
            try {
                await this.$refs.editDeviceForm.validate();
                this.submitLoading = true;

                const formData = new FormData();
                for (const key in this.editDeviceForm) {
                    if (Object.prototype.hasOwnProperty.call(this.editDeviceForm, key)) {
                        formData.append(key, this.editDeviceForm[key]);
                    }
                }
                // 显式添加houseId参数
                formData.append('houseId', this.editDeviceForm.houseId || '');

                if (this.editDeviceImageFile) {
                    formData.append('photo', this.editDeviceImageFile);
                }

                const response = await edit(formData);

                if (response.code === 200 || response.success) {
                    this.$message.success('设备修改成功！');
                    this.editDeviceModalVisible = false;
                    await this.loadAllDevices(); // 重新加载全量数据
                } else {
                    this.$message.error(response.message || '设备修改失败');
                }
            } catch (error) {
                console.error('修改设备失败：', error);
                if (error.name !== 'ValidationError') {
                    const errorMsg = error.response?.data?.message || '提交过程中发生错误，请重试。';
                    this.$message.error(errorMsg);
                }
            } finally {
                this.submitLoading = false;
            }
        },

        handleImageRemove(file, fileList) {
            console.log(`文件 ${file.name} 已移除`, fileList);
        },

        handleImagePreview(file) {
            this.previewImageUrl = file.url || URL.createObjectURL(file.raw);
            this.previewTitle = `图片预览: ${file.name}`;
            this.previewVisible = true;
        },

        handleExceed() {
            this.$message.warning(`每个区域最多只能上传 2 张图片（设备图片最多1张）`);
        },

        previewImage(url, title) {
            if (!url) return this.$message.warning('暂无图片可预览');
            this.previewImageUrl = url;
            this.previewTitle = `图片预览: ${title}`;
            this.previewVisible = true;
        },

        downloadImage() {
            if (!this.previewImageUrl) return this.$message.warning('暂无图片可下载');
            try {
                const link = document.createElement('a');
                link.href = this.previewImageUrl;
                link.download = this.previewTitle.replace('图片预览: ', '') || 'image';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                if (this.previewImageUrl.startsWith('blob:')) URL.revokeObjectURL(this.previewImageUrl);
                this.$message.success('图片下载成功');
            } catch (error) {
                console.error('下载图片失败:', error);
                this.$message.error('图片下载失败，请重试');
            }
        },

        getRoomName(roomId) {
            if (!roomId) return '未知';
            const room = this.roomList.find(item => item.id == roomId);
            return room ? room.roomName : '未知';
        }
    }
};
</script>

<style lang="scss" scoped>
.device-management-page {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    background-color: #f9f9f9;
}

.main-tabs,
.sub-tabs {
    :deep(.el-tabs__content) {
        display: none;
    }
}

.content-area {
    display: flex;
    flex-direction: column;
    gap: 15px;
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.search-form {
    margin-bottom: 10px;
}

.pagination-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}

.table-header {
    background-color: #f5f7fa !important;
    font-weight: bold;
}

.text-danger {
    color: #f56c6c !important;
    font-weight: bold;
}

.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;

    .preview-image {
        max-width: 100%;
        max-height: 100%;
        cursor: pointer;
    }

    .no-image {
        color: #c0c4cc;
        font-size: 24px;
    }
}

:deep(.device-modal .el-form-item) {
    margin-bottom: 18px;
}

:deep(.device-modal .el-table .el-form-item) {
    margin-bottom: 0;
}

:deep(.device-modal .el-table .el-table__cell) {
    padding: 8px 0;
}

// 图片预览弹窗样式优化
:deep(.image-preview-dialog .el-dialog__body) {
    padding: 20px;
    text-align: center;
}

.preview-img {
    border-radius: 4px;
}
</style>